<template>

        <w-transition-bounce>
        <w-alert
          class="my0 mb2 text-light"
          v-if="success"
          success
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{ success }}
        </w-alert>
        </w-transition-bounce>
        <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="salah"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{salah}}
        </w-alert>
      </w-transition-bounce>

      <w-notification
        v-if="$page.props.flash.notify"
        success
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notify = ''"
        >
        {{$page.props.flash.notify}}
      </w-notification>

      <w-notification
        v-if="$page.props.flash.notifyerror"
        error
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notifyerror = ''"
        >
        {{$page.props.flash.notifyerror}}
      </w-notification>

  <layout :showuserinfo="false" >
  	<div class="container-fluid  h-100">
            <div class="page-wrapper-portal">
                
                <div class="card card-scroll" >
                   
                   
                    <div class="card-body">

                        <!-- -->
                        <div class="row">
                            <div class="col-lg-9">
                                <div class="row justify-content-center">
                                    
                                    <!-- -->
                                    <div class="">
                                        <div class="card report-card">
                                            <div class="card-body">
                                                
                                                

                                                <!-- -->
                                                                                                        <!-- -->
                                                <div class="col-lg-12">
                                                    <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title"><b class="text-primary"> Lupa Tukar Kata Laluan</b></h4>
                                    </div><!--end card-header-->
                                     <w-form @validate="changePassword">
                                         <input type="hidden" name="token" v-model="form.token" >

                                    <div class="card-body">
                                        <div class="table-responsive shopping-cart">
                                             <div class="form-group">
                                                <label for="email" class="form-label  mb-2">Emel</label>
                                                <div class="input-group">                                                                                       
                                                   <w-input 
                                                    outline
                                                    placeholder="Sila Masukkan Emel Pengguna"
                                                    type="email"  
                                                    name="email"
                                                    v-model="form.email"
                                                    disabled
                                                    :validators="[validators.required, validators.email]"
                                                />              
                                                </div>  
                                                <template v-if='email_wujud'>
                                                <div style="color: red;">
                                                {{email_wujud}}  
                                                </div>  
                                                </template>                                   
                                            </div><!--end form-group-->

                                            

                                            <div class="form-group mt-2">
                                                <label for="password" class="form-label  mb-2">Kata Laluan Baharu</label>                                            
                                                <div class="input-group">                                    
                                                    <w-input 
                                                    outline
                                                    placeholder="Sila Masukkan Kata Laluan Baharu"
                                                    :type="isPassword ? 'password' : 'text'"
                                                    :inner-icon-right="isPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                                                    @click:inner-icon-right="isPassword = !isPassword"   
                                                    name="password"
                                                    v-model="form.password"
                                                    :validators="[validators.required, validators.regex, validators.min8]"
                                                />          
                                                </div>                               
                                            </div><!--end form-group--> 
        
                                            <div class="form-group mt-2">
                                                <label for="password_confirmation" class="form-label">Sah Kata Laluan Baharu</label>                                            
                                                <div class="input-group mb-2">                               
                                                     <w-input 
                                                    outline
                                                    placeholder="Sila Ulang Kata Laluan Baharu"
                                                     :type="isPassword1 ? 'password' : 'text'"
                                                    :inner-icon-right="isPassword1 ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                                                    @click:inner-icon-right="isPassword1 = !isPassword1"   
                                                    name="password_confirmation"
                                                    v-model="form.password_confirmation"
                                                    :validators="[validators.required, validators.regex, validators.min8]"
                                                />          
                                                </div>
                                                 <template v-if="form.password != form.password_confirmation">
                                                <div style="color: red;">Kata Laluan tidak sepadan</div></template>  
                                            </div>

                                             <button class="btn btn-lupa-katalaluan mt4 mb2 ml2" type="submit">Simpan</button>

                                            <!-- <code>* <b>Nota</b> : Sila Pastikan Setiap Pembayaran adalah tepat dan betul, sebelom melakukan pembayaran. Terima Kasih</code> -->

                                        </div><!--end re-table-->

                                    </div><!--end card-body-->
                                     </w-form>
                                </div>
                                                </div><!--end col--> 


                                                <!-- -->



                                            </div><!--end card-body--> 

                                        </div><!--end card--> 
                                    </div> <!--end col--> 

                                    <!-- -->

                                </div><!--end row-->

                            </div><!--end col-->

                        </div><!--end row-->
                        <!-- -->

                    </div><!--end card-body--> 
                </div>
                

            </div>

        </div>
  	
  </layout>
</template>

<script type="text/javascript">
import ZResource from '@/Modules/z-resource'

	export default {
    extends: ZResource,
	components: {
	  
	},
    props: {
        token: String,
        email: String
    },
	setup () {

	},
	data() {
	    return {
            isPassword: true,
            isPassword1: true,
            email_wujud: '',
            success : '',
            salah : '',

      form: {
	    valid: null,
	    submitted: false,
	    sent: false,
	    errorsCount: 0,
	    old_password: '',
        password: '',
        password_confirmation: '',
        no_id: '',
		email: this.email,
        token: this.token
	  },


      

	}},
	methods: {
	 
      changePassword() {
            this.$inertia.post('reset-password',this.form)
            
            //  this.$zcomm.post('reset.password.post',this.form)
            //              .catch(err => {
            //            if (err.response.data.errors.email == "The selected email is invalid."){
            //                 //   console.log(err.response.data.errors.email);

            //                     this.email_wujud = 'Emel yang dimasukkan tidak wujud'
  
            //             }
            //             })
                       
        },
         notify(msg, success = true) {
            if(success)
            
            this.success = msg
            else
            this.salah = msg
        }
	},
  mounted() {


      
  }
}
</script>
<style type="text/css">
	.card-scroll {
    height: 510px;
    max-height: 510px;
    overflow-y: scroll;
    background: ivory;
}
</style>